export function isDoubleDimensionArray(arr : string[] | string[][]): arr is string[][] {
  if (Array.isArray(arr[0])) {
    return true
  } else return false;
}